import React from 'react';
import { Button } from 'reactstrap';

const generateMonthlyActivityColumns = (
  cabinCrews,
  handleCreateActivity,
  handleCounterClick,
  activeFilter,
  holidaySet = new Set(),
) => {
  if (!cabinCrews || cabinCrews.length === 0) return [];

  const firstCabinCrew = cabinCrews[0];
  const dayKeys = Object.keys(firstCabinCrew.days || {}).sort();

  const fixedColumns = [
    {
      Header: () => (
        <div className="text-center" style={{ minWidth: '160px', padding: '8px 4px' }}>
          <div
            className="font-weight-bold mb-2"
            style={{
              fontSize: '1rem',
              backgroundColor: '#f8f9fa',
              padding: '4px 8px',
              borderRadius: '4px',
              border: '1px solid #dee2e6',
            }}
          >
            Documento
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
            }}
          >
            {/* On Trip - Leyenda */}
            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="En Viaje"
            >
              <i
                className="fa fa-bus"
                style={{
                  fontSize: '1.1rem',
                  color: '#0066cc',
                }}
              />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>En Viaje</span>
            </div>

            {/* On Hold - Leyenda */}
            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="En Retén"
            >
              <i
                className="fa fa-pause-circle"
                style={{
                  fontSize: '1.1rem',
                  color: '#ff9800',
                }}
              />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>En Retén</span>
            </div>

            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="Reserva"
            >
              <i className="fa fa-hourglass-half" style={{ fontSize: '1.1rem', color: '#6f42c1' }} />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>Reserva</span>
            </div>

            {/* Unavailable - Leyenda */}
            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="No Disponibles"
            >
              <i
                className="fa fa-times-circle"
                style={{
                  fontSize: '1.1rem',
                  color: '#dc3545',
                }}
              />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>No Disp.</span>
            </div>

            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="Provincia - Lima"
            >
              <i
                className="fa fa-check-circle"
                style={{
                  fontSize: '1.1rem',
                  color: '#28a745',
                }}
              />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>Prov-Lima</span>
            </div>

            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="Disponibles"
            >
              <i
                className="fa fa-circle-o"
                style={{
                  fontSize: '1.1rem',
                  color: '#6c757d',
                }}
              />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>Disponibles</span>
            </div>
            <div
              style={{
                padding: '6px 8px',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
                cursor: 'default',
              }}
              title="Mantenimiento"
            >
              <i
                className="fa fa-wrench"
                style={{
                  fontSize: '1.1rem',
                  color: '#17a2b8',
                }}
              />
              <span style={{ color: '#6c757d', fontSize: '0.75rem' }}>Mant.</span>
            </div>
          </div>
        </div>
      ),
      accessor: 'documentNumber',
      className: 'text-center',
      width: 160,
      filterable: true,
    },
    {
      Header: () => (
        <div className="text-center" style={{ minHeight: '200px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '8px' }}>
          Nombre
        </div>
      ),
      accessor: 'fullName',
      className: 'text-left',
      width: 250,
      filterable: true,
    },
    {
      Header: () => (
        <div className="text-center" style={{ minHeight: '200px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '8px' }}>
          Base
        </div>
      ),
      accessor: 'baseLocation',
      className: 'text-center',
      width: 150,
      filterable: true,
    },
    {
      Header: () => (
        <div className="text-center" style={{ minHeight: '200px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '8px' }}>
          Estado
        </div>
      ),
      accessor: 'status',
      className: 'text-center',
      width: 100,
    },
    {
      Header: () => (
        <div className="text-center" style={{ minHeight: '200px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '8px' }}>
          Detalle Conflicto
        </div>
      ),
      accessor: 'statusDescription',
      className: 'text-center',
      width: 150,
    },
  ];

  const calculateDayCounters = (dateKey) => {
    let onTrip = 0;
    let onHold = 0;
    let maintenance = 0;
    let unavailable = 0;
    let free = 0;
    let noActivity = 0;
    let reserve = 0;

    cabinCrews.forEach((cabinCrew) => {
      if (!cabinCrew.dayEventTypes) return;

      const dayEventType = cabinCrew.dayEventTypes[dateKey] || 'EMPTY';
      const eventTypes = dayEventType.split('|');

      const hasItinerary = eventTypes.includes('ITINERARY');
      const hasReten = eventTypes.includes('RETEN');
      const hasMaintenance = eventTypes.includes('MAINTENANCE');
      const hasReserve = eventTypes.includes('RESERVE');
      const hasMovement = eventTypes.includes('MOVEMENT');
      const hasFreeArrivedLima = eventTypes.includes('FREE_ARRIVED_LIMA');

      if (hasItinerary) {
        onTrip += 1;
      } else if (hasReten) {
        onHold += 1;
      } else if (hasMaintenance) {
        maintenance += 1;
      } else if (hasReserve) {
        reserve += 1;
      }else if (hasMovement) {
        unavailable += 1;
      } else if (hasFreeArrivedLima) {
        free += 1;
      } else {
        noActivity += 1;
      }
    });

    return { onTrip, onHold, maintenance,reserve, unavailable, free, noActivity };
  };

  const dayColumns = dayKeys.map((dateKey) => {
    // eslint-disable-next-line
    const [year, month, day] = dateKey.split('-');
    const headerDate = `${day}/${month}`;

    const counters = calculateDayCounters(dateKey);
    const isHoliday = holidaySet.has(dateKey);

    const isActive = (filterType) =>
      activeFilter &&
      activeFilter.dateKey === dateKey &&
      activeFilter.filterType === filterType;

    return {
      Header: () => (
        <div className="text-center" style={{ minWidth: '160px', padding: '8px 4px' }}>
          <div
            className="font-weight-bold mb-2"
            style={{
              fontSize: '1rem',
              backgroundColor: '#f8f9fa',
              padding: '4px 8px',
              borderRadius: '4px',
              border: '1px solid #dee2e6',
            }}
          >
            {headerDate}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
            }}
          >
            {/* On Trip */}
            <button
              style={{
                padding: '6px 8px',
                border: isActive('ON_TRIP') ? '2px solid #0066cc' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('ON_TRIP') ? '#e3f2fd' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="En Viaje - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'ON_TRIP')}
              onMouseEnter={(e) => {
                if (!isActive('ON_TRIP')) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('ON_TRIP')) {
                  e.currentTarget.style.backgroundColor = '#fff';
                }
              }}
            >
              <i
                className="fa fa-bus"
                style={{
                  fontSize: '1.1rem',
                  color: '#0066cc',
                }}
              />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>
                {counters.onTrip}
              </strong>
            </button>

            {/* On Hold */}
            <button
              style={{
                padding: '6px 8px',
                border: isActive('ON_HOLD') ? '2px solid #ff9800' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('ON_HOLD') ? '#fff3e0' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="En Retén - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'ON_HOLD')}
              onMouseEnter={(e) => {
                if (!isActive('ON_HOLD')) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('ON_HOLD')) {
                  e.currentTarget.style.backgroundColor = '#fff';
                }
              }}
            >
              <i
                className="fa fa-pause-circle"
                style={{
                  fontSize: '1.1rem',
                  color: '#ff9800',
                }}
              />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>
                {counters.onHold}
              </strong>
            </button>

            {/* Reserve */}
            <button
              style={{
                padding: '6px 8px',
                border: isActive('RESERVE') ? '2px solid #6f42c1' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('RESERVE') ? '#efe7fb' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="Reserva - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'RESERVE')}
              onMouseEnter={(e) => {
                if (!isActive('RESERVE')) e.currentTarget.style.backgroundColor = '#f5f5f5';
              }}
              onMouseLeave={(e) => {
                if (!isActive('RESERVE')) e.currentTarget.style.backgroundColor = '#fff';
              }}
            >
              <i className="fa fa-hourglass-half" style={{ fontSize: '1.1rem', color: '#6f42c1' }} />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>{counters.reserve}</strong>
            </button>

            {/* Unavailable */}
            <button
              style={{
                padding: '6px 8px',
                border: isActive('UNAVAILABLE') ? '2px solid #dc3545' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('UNAVAILABLE') ? '#ffebee' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="No Disponibles - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'UNAVAILABLE')}
              onMouseEnter={(e) => {
                if (!isActive('UNAVAILABLE')) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('UNAVAILABLE')) {
                  e.currentTarget.style.backgroundColor = '#fff';
                }
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{
                  fontSize: '1.1rem',
                  color: '#dc3545',
                }}
              />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>
                {counters.unavailable}
              </strong>
            </button>

            <button
              style={{
                padding: '6px 8px',
                border: isActive('FREE') ? '2px solid #28a745' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('FREE') ? '#e8f5e9' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="Provincia - Lima - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'FREE')}
              onMouseEnter={(e) => {
                if (!isActive('FREE')) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('FREE')) {
                  e.currentTarget.style.backgroundColor = '#fff';
                }
              }}
            >
              <i
                className="fa fa-check-circle"
                style={{
                  fontSize: '1.1rem',
                  color: '#28a745',
                }}
              />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>
                {counters.free}
              </strong>
            </button>


            <button
              style={{
                padding: '6px 8px',
                border: isActive('NO_ACTIVITY') ? '2px solid #6c757d' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('NO_ACTIVITY') ? '#e9ecef' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="Disponibles - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'NO_ACTIVITY')}
              onMouseEnter={(e) => {
                if (!isActive('NO_ACTIVITY')) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('NO_ACTIVITY')) {
                  e.currentTarget.style.backgroundColor = '#fff';
                }
              }}
            >
              <i
                className="fa fa-circle-o"
                style={{
                  fontSize: '1.1rem',
                  color: '#6c757d',
                }}
              />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>
                {counters.noActivity}
              </strong>
            </button>
            {/* Maintenance */}
            <button
              style={{
                padding: '6px 8px',
                border: isActive('MAINTENANCE') ? '2px solid #17a2b8' : '1px solid #e9ecef',
                borderRadius: '4px',
                backgroundColor: isActive('MAINTENANCE') ? '#d1ecf1' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '8px',
              }}
              title="Mantenimiento - Click para filtrar"
              onClick={() => handleCounterClick(dateKey, 'MAINTENANCE')}
              onMouseEnter={(e) => {
                if (!isActive('MAINTENANCE')) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('MAINTENANCE')) {
                  e.currentTarget.style.backgroundColor = '#fff';
                }
              }}
            >
              <i
                className="fa fa-wrench"
                style={{
                  fontSize: '1.1rem',
                  color: '#17a2b8',
                }}
              />
              <strong style={{ color: '#212529', fontSize: '0.9rem' }}>
                {counters.maintenance}
              </strong>
            </button>
          </div>
        </div>
      ),
      accessor: `days.${dateKey}`,
      className: 'text-center',
      width: 220,

      columnColor: isHoliday ? '#c7fafd' : undefined,
      // eslint-disable-next-line 
      Cell: ({ value, original }) => {
        if (!value || value === '') {
          return (
            <Button
              color="link"
              size="sm"
              onClick={() => handleCreateActivity(original, dateKey)}
              title="Crear actividad"
            >
              <i className="fa fa-plus-circle text-muted" />
            </Button>
          );
        }
        // eslint-disable-next-line
        const lines = value.split('\n');
        return (
          <div style={{ whiteSpace: 'pre-line', fontSize: '0.85rem' }}>
            {lines.map((line, idx) => (
              // eslint-disable-next-line
              <div key={idx}>{line}</div>
            ))}
          </div>
        );
      },
    };
  });

  return [...fixedColumns, ...dayColumns];
};

export default generateMonthlyActivityColumns;